import React from 'react';

import { AboutUs, Founder, FindUs, Footer, Gallery, Header, Intro, Services, Price } from './container';
import { Navbar } from './components';
import './App.css';

const App = () => (
  <div>
    <Navbar />
    <Header />
    <AboutUs />
    <Services />
    <Price />
    <Founder />
    <Intro />
    <Gallery />
    <FindUs />
    <Footer />
  </div>
);

export default App;
